<template>
  <div id="app">
    <RotatePhone></RotatePhone>
    <router-view />
  </div>
</template>

<script>
import RotatePhone from './components/RotatePhone/index.vue';
export default {
  components: { RotatePhone },
  data() {
    return {};
  },
};
</script>

<style lang="less">
body {
  background-color: #f5f5f5;
  color: @primaryColor;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.gray {
  color: #999;
}
// 问号图标
.ques-icon {
  position: relative;
  display: inline-block;

  width: 30px;
  height: 30px;
  margin-left: 0;
  background: url(~@/assets/images/ques-icon.png) no-repeat;
  background-size: 96% auto;
}
// 增大图标点击区域
.inc-area {
  position: relative;
  &::before {
    content: '';
    position: absolute;
    width: 100px;
    height: 100px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
// 右箭头图标
.right-arrow {
  width: 26px;
  height: 26px;
  background: url(~@/assets/images/icon_arrow.png) no-repeat;
  background-size: contain;
}
.pagnation-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 43px;
  .van-pagination {
    margin-right: 30px;
  }
  .van-pagination__item {
    // border: 1px solid #fd9b21;
    border: none;
    background: none;
    font-size: 32px;
    color: #8c8c8c;
  }
  .van-pagination__item--active {
    color: #fd9b21;
    font-size: 32px;
  }
  .van-dropdown-menu__title::after {
    display: none;
  }
  .jump-wrap {
    color: #8c8c8c;
    font-size: 28px;
  }
  .van-dropdown-menu {
    margin: 0 10px;
  }
}
.table-wrap .fixed-td {
  border-right: 1px solid #efefef;
}
</style>
<style>
.table-wrap {
  margin-top: 34px;
}
.p-datatable-responsive-scroll > .p-datatable-wrapper > table {
  width: 120%;
}
.billDetails > .p-datatable-wrapper > table {
  width: 100%;
}
.p-datatable-wrapper {
  background: #fff;
}
.p-component {
  font-size: 24px;
  white-space: nowrap;
  font-weight: 400;
}
.p-datatable.p-datatable-sm .p-datatable-thead > tr > th {
  padding: 15px;
  text-align: center;
  color: #262626;
}
.p-datatable .p-column-header-content {
  justify-content: center;
}
.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {
  padding: 34px 12px;
  text-align: center;
  color: #595959;
}
.p-datatable .p-datatable-tbody > tr > td .p-row-toggler {
  width: 0.2rem;
  height: 0.2rem;
}
.pi {
  font-size: 0.12rem;
}
.p-datatable .p-datatable-tbody > tr > td .p-row-toggler:focus {
  box-shadow: none;
  outline: none;
}
.p-datatable .p-datatable-tbody > tr > td .p-row-toggler:enabled:hover {
  background: none;
}
.p-datatable-row-expansion td {
  justify-content: center;
}
</style>
